import React, { useEffect, useState } from "react";
import axios from "axios";
import useSEO from "../../hooks/useSEO";
import { MyApi } from "../../MyApi";

import Banner from "./Banner"; 
import WhyTravel from "./WhyTravel";
import PopularTours from "./PopularTours";
import HomeTestimonials from "./HomeTestimonials";
import PopularTours2 from "./PopularTours2";
import LocalTours from "./LocalTours";

export default function Home() {
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    const fetchSEO = async () => {
      try {
        const res = await axios.get(MyApi.BASE_URL + "site-setting", {
          headers: { Authorization: MyApi.SECRET_KEY },
        });

        if (res.data.status && res.data.data) {
          setSeoData(res.data.data);
        }
      } catch (err) {
        console.error("SEO API error", err);
      }
    };

    fetchSEO();
  }, []);

  // 🔹 Apply SEO only when API data is ready
  useSEO(
    seoData
      ? {
          title: seoData.metatitle,
          description: seoData.description,
          keywords: seoData.keywords,
          canonical: seoData.canonical || "https://kashijourneys.com/",
          ogImage: seoData.ogImage || "",
        }
      : {}
  );

  return (
    <div>
      <Banner />
      <LocalTours />
      <WhyTravel />
      <PopularTours   />
      <HomeTestimonials />
      <PopularTours2  />
    </div>
  );
}
